import type { NavIcons } from "../../components/NavigationBar/NavIcon/NavIcon";
import type { NavigationConfig } from "../../components/NavigationBar/type";
import type { TranslationKeys } from "../../intl/intl.types";
import type {
  RouteConfigMenu,
  RouteConfigSubMenu,
} from "./navigationConfigTypes";
export type MmRouteConfigSubMenu = {
  textKey: TranslationKeys;
  subRoutes: (Omit<RouteConfigSubMenu, "allowedPermissions"> & {
    allowedPermissions?: string[];
  })[];
};

export type MmRouteConfig = Omit<
  RouteConfigMenu,
  "menu" | "allowedPermissions"
> & {
  allowedPermissions?: string[];
};

export type MmRouteConfigMenu = MmRouteConfig & {
  menu: Omit<RouteConfigMenu["menu"], "icon" | "subRoutes"> & {
    position: NavigationConfig[number]["position"];
    icon: NavIcons;
    subRouteSections?: MmRouteConfigSubMenu[];
  };
};

export const isMmRouteConfigMenu = (x: MmRouteConfig): x is MmRouteConfigMenu =>
  "menu" in x;
